import Home from "../pages/Home";
import AboutUs from "@/pages/AboutUs";
import ServicesPage from "@/pages/ServicesPage";
import PartnersPage from "@/pages/PartnersPage";
import ClientsPage from "@/pages/ClientsPage";
import ProductsPage from "@/pages/ProductsPage";
import AberraPage from "@/pages/AberraPage";
import HobbotPage from "@/pages/HobbotPage";
import LendProPage from "@/pages/LendProPage";
import ProvestPage from "@/pages/ProvestPage";
import FaqsPage from "@/pages/FaqsPage";
import ContactUsPage from "@/pages/ContactUsPage";
import HireUsPage from "@/pages/HireUsPage";
import OurServices from "@/pages/OurServices";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import CookiePolicy from "@/pages/CookiePolicy";
import ReturnPolicy from "@/pages/RefundPolicy";
import PurchaseService from "@/pages/PurchasePage";
import PaymentPage from "@/pages/PaymentPage";

PurchaseService;

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about-us",
    name: "about-us",
    component: AboutUs,
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: ContactUsPage,
  },
  {
    path: "/faqs",
    name: "faqs",
    component: FaqsPage,
  },
  {
    path: "/hire-us",
    name: "hire-us",
    component: HireUsPage,
  },
  {
    path: "/services",
    name: "services",
    component: ServicesPage,
  },
  {
    path: "/clients",
    name: "clients",
    component: ClientsPage,
  },
  {
    path: "/partners",
    name: "partners",
    component: PartnersPage,
  },
  {
    path: "/products",
    name: "products",
    component: ProductsPage,
  },
  {
    path: "/products/aberra-messaging",
    name: "aberra-messaging",
    component: AberraPage,
  },
  {
    path: "/products/hobbot",
    name: "hobbot",
    component: HobbotPage,
  },
  {
    path: "/products/lendpro",
    name: "lendpro",
    component: LendProPage,
  },
  {
    path: "/products/provest",
    name: "provest",
    component: ProvestPage,
  },

  {
    path: "/our-services",
    name: "our-services",
    component: OurServices,
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
  },

  {
    path: "/terms-and-conditions",
    name: "terms-and-conditions",
    component: TermsAndConditions,
  },

  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy,
  },
  {
    path: "/return-policy",
    name: "return-policy",
    component: ReturnPolicy,
  },

  {
    path: "/purchase-service",
    name: "purchase-service",
    component: PurchaseService,
  },
  {
    path: "/payment",
    name: "payment",
    component: PaymentPage,
  },
];
